<template>
<div >
  <Validator label="" :v="v" input >
    <div class="custom-input" @click="onClick" :width="width">
        <div multiple
        :aria-label="label"
        tabindex="0"
        :disabled="disabled"
        :class="{
          'outline-disabled' : disabled,
          'outline-block': true,
          'outline-block--focus': inputFocus,
          'outline-border-error': v.$invalid && v.$dirty || validation
        }" >
            <div style="padding: 20px; display: flex; flex-flow: row wrap; gap: 5px;" >
              <div v-for="(elemento) in opcoes" :key="elemento.key" >
                <v-chip  :color=" (disabled) ? '#BDBDBD' :'#01848C'" :class="{'white--text': !disabled, 'grey--text': disabled}" v-if="elemento.selecionado && !ehMobile" close closable @click:close="retirarSelecionado(elemento)">{{elemento.title}}</v-chip>
                <v-chip :color=" (disabled) ? '#BDBDBD' :'#01848C'" :class="{'white--text': !disabled, 'grey--text': disabled}" v-if="elemento.selecionado && ehMobile" close closable @click:close="retirarSelecionado(elemento)">{{elemento.title.substr(0,10).concat('...')}}</v-chip>
              </div>
            </div>
            <span
              style="top: 12px;"
              :class="{
                'outline-label' : true,
                'outline-label-up': (value !== '') || inputFocus,
                'outline--focus': inputFocus,
                'outline-error': v.$invalid && v.$dirty
              }">
              {{ label }}
            </span>
            <!-- <div class="outline-disabled"></div> -->
            <v-icon class="outline-icon-right" style="position: absolute; ">arrow_drop_down</v-icon>
        </div>

    <v-dialog v-model="inputClick"  max-width="500px" scrollable  @input="inputFocus = false">
      <v-card>
        <v-card-title class="headline grey lighten-4 mb-4"  >
          <div>
            <CheckBoxCustom label="Selecionar todos" @click="toggle" :value="todosSelecionados" :true-value="true" :false-value="false" />
          </div>
        </v-card-title>
        <v-card-text>
          <div v-for="(op, index) in opcoes" :key="op.key">
            <CheckBox v-model="opcoes[index].selecionado"
                      :label="(!op.disabled) ? op.title : `${op.title} - ${op.observacaoDesabilitado}`"
                      :val="op"
                      @input="onChange"
                      :disabled="op.disabled"/>
          </div>
        </v-card-text>
        <v-divider></v-divider>
          <v-card-actions  class="mt-2 mb-2 d-flex justify-center">
            <v-btn class="rounded-sm font-weight-regular white--text" color="teal" small @click="inputClick = false" >OK</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>




</div>
  </Validator>
</div>

</template>



<script>
import Validator from './Valitador.vue';
import CheckBox from './CheckBox.vue';
import CheckBoxCustom from './CheckBoxCustom.vue';

export default {
  name: 'MultipleSelect',
  components: {
    Validator,
    CheckBox,
    CheckBoxCustom,
  },
  props: {
    value: [ String, Number, Object, Array ],
    options: Array,
    width: String,
    label: String,
    disabled: {
      type: Boolean,
      default: false,
    },
    validation: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    v: {
      type: Object,
      default() {
        return {
          $invalid: false,
          $dirty: false,
          $touch: () => {},
        };
      },
    },
  },
  data() {
    return {
      inputFocus: false,
      inputClick: false,
      exibirOpcoes: false,
      opcoes: [],
      ehMobile: screen.width < 640 || screen.height < 480,
    };
  },
  created() {
   document.addEventListener('keydown', this.onKeyDown);
  },
  watch: {
    options: {
      handler(after) {
        this.opcoes = after

      }
    },

  },

  computed: {
    todosSelecionados() {
      return this.opcoes.filter(e => e.selecionado === true && e.disabled === false).length === this.opcoes.filter(e => e.disabled === false).length
    },

  },

  methods: {
    onKeyDown(event) {
      if (event.ctrlKey && event.key === 'Enter') {
        this.inputClick = false
      }
    },
    retirarSelecionado(registro) {
      const index = this.opcoes.indexOf(registro)
      if(index >= 0){
        this.opcoes[index].selecionado = false
        this.onChange()
      }else return
    },
    onClick() {
     if(this.disabled) return
      this.inputClick = true;
      this.inputFocus = true;
      this.exibirOpcoes = !this.exibirOpcoes

    },
    onFocus() {
      this.inputFocus = true;
      this.$emit('focus');
    },
    onBlur() {
      this.v.$touch();
      this.inputFocus = false;
      this.exibirOpcoes = false
      this.$emit('blur');
    },
    input(event) {
      if(this.disabled) return
      this.$emit('input', this.opcoes)
    },
    onChange(e) {
      if(this.disabled) return
      this.v.$touch();
      this.$emit('change', this.opcoes);
    },
    toggle () {
                // this.$nextTick(() => {
                  if (this.todosSelecionados) {
                     this.opcoes = this.options.map(function(e) {
                            return {
                              key: e.key,
                              selecionado:  false,
                              title: e.title,
                              value: e.value,
                              disabled: e.disabled,
                              observacaoDesabilitado: e.observacaoDesabilitado
                            }
                    })


                  } else {
                    this.opcoes = this.options.map(function(e) {

                          return {
                            key: e.key,
                            selecionado: (e.disabled) ? false : true,
                            title: e.title,
                            value: e.value,
                            disabled: e.disabled,
                            observacaoDesabilitado: e.observacaoDesabilitado
                          }
                    })

                  }
                  this.onChange()

              //  })
              }
  },
};
</script>

<style lang="scss" scoped>

.errorBorder{
  border: 1px solid red;
}

.outline-input-select {
  padding: 12px 28px 14px 16px!important;
}
.outline-disabled {
  background-color: #eee;
  color: #828282;
  padding:  28px 14px 16px;
  z-index: 0;
}


.select-custom{
  width: 100%;
  border: 1px solid #b0b0b0;
  border-radius: 4px;
  font-size: 17px;
  padding: 2px;
  background-color: white;
  -webkit-appearance: menulist;
  height: 31px;

  &:disabled{
    background-color: #e8e8e8;
  }

  &::-ms-expand{
    display: block;
    visibility: initial;
  }
}




</style>
